import SignUpSuccessPage from "#/components/signup-success"
import React from "react"

export default function SignUpSuccess() {
  return <SignUpSuccessPage />
}
